export default __webpack_public_path__ + "static/media/multiweekUpgrade.43810e71.png";